// tslint:disable:max-line-length
import React from 'react';
import Modal from 'react-modal';
import styles from './styles';

interface VendorPasscodeInfoModalProps {
  closeModal: () => void;
  isOpen: boolean;
  isVirtualDirectoryEnabled: boolean;
  leasingOfficeDisplayName: string;
  supportPhoneNumber?: string | null;
}

Modal.setAppElement('#root');

export const VendorPasscodeInfoModal = (props: VendorPasscodeInfoModalProps) => {
  const { closeModal, isOpen, isVirtualDirectoryEnabled, leasingOfficeDisplayName } = props;

  return (
    <Modal
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={closeModal}
      isOpen={isOpen}
    >
      <div className={styles.modal}>
        <div className={styles.modalText}>
          <h1 className={styles.title}>What is a Vendor Passcode?</h1>
          <span className={styles.spacer}></span>
          <div className={styles.text}>
            <p>A unique vendor passcode is granted by property staff to frequent vendors.</p>
            {isVirtualDirectoryEnabled &&
              <p>If you do not have a Vendor Passcode, please use the Property Directory to call the {leasingOfficeDisplayName}.</p>
            }
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VendorPasscodeInfoModal;
